<template>
    <v-data-table
        :headers="realHeaders"
        :items="list"
        class="elevation-1"
        :items-per-page="-1"
        hide-default-footer
        disable-sort
    >
        <template #item="row">
            <tr>
                <td v-for="(header, i) in realHeaders" :key="i">
                    <template v-if="header.text === 'Устройство'">
                        <router-link :to="`/devices/view/${row.item.deviceId}`">
                            {{ getCellValue(row.item, header) }}
                        </router-link>
                    </template>
                    <template v-else>
                        {{ getCellValue(row.item, header) }}
                    </template>
                </td>
            </tr>
        </template>
    </v-data-table>
</template>

<script lang="ts">
import Component from 'vue-class-component'
import {PowerPacket} from '@/models/PowerPacket'
import Browser, {Header} from '@/mixins/Browser'
import {displayTime} from '@/utils/datetime'

@Component
export default class PacketBrowser extends Browser<PowerPacket>
{
    defaultHeaders: Header<PowerPacket>[] = [
        {text: 'ID', value: 'id', align: 'start'},
        {text: 'Код устройства', value: 'deviceCode'},
        {text: 'Устройство', value: p => p.device?.name ?? ''},
        {text: 'Мощность', value: p => p.power + ' Вт'},
        {text: 'Принято в', value: p => displayTime(p.receivedAt)},
        {text: 'Обработано в', value: p => displayTime(p.processedAt)},
    ]

    async fetchList() {
        this.list = await this.api.listPowerPackets({
            ...this.filters,
            expand: ['device'],
        })
    }
}
</script>
